import { render, staticRenderFns } from "./StudiesTable.vue?vue&type=template&id=155eb065&"
import script from "./StudiesTable.vue?vue&type=script&lang=js&"
export * from "./StudiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports